import {
  SET_FETCH_STATUS,
  SET_FETCH_DEFAULTS,
  REQUEST_STATE,
  SET_FETCH_LOADING,
  LOAD_IO_STATE_BY_BOOK_ID,
  IMAGES_LOADING,
  AUTOFILL_FINISHED,
  CONVERT_FINISHED,
} from '../../action-types/entities/io';

import {
  getDomain } from '../../helpers/getParams';
import {
  configExist } from '../../helpers';

export const setFetchDefaults = () => ({
  type: SET_FETCH_DEFAULTS,
});

export const autofillFinished = status => ({
  type: AUTOFILL_FINISHED,
  status,
});

export const convertFinished = status => ({
  type: CONVERT_FINISHED,
  status,
});

export const setFetchLoading = isLoading => ({
  type: SET_FETCH_LOADING,
  isLoading,
});

export const setFetchStatus = status => ({
  type: SET_FETCH_STATUS,
  status,
});

export const requestState = () => ({
  type: REQUEST_STATE,
});

export const imagesLoading = status => ({
  type: IMAGES_LOADING,
  status,
});

export const saveState = () => (dispatch, getState) => {
  // dispatch(requestState());
  const referer = getDomain();

  const bookState = getState();
  const ProductIdMerge = Object.assign(
    {}, { json: bookState },
    { weddingId: getState().bookProperties.productID },
  );

  const saveStateUrl = configExist('saveStateUrl', referer);
  const apiSettings = {
    url: `${saveStateUrl}`,
    getState: JSON.stringify(ProductIdMerge),
  };
  const {
    url, getState: apiState,
  } = apiSettings;

  const data = apiState;

  fetch(url, {
    method: 'POST',
    body: data,
    mode: 'no-cors',
    credentials: 'include',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  })
    .then((response) => {
      if (response.status !== 200) {
        /*  return dispatch(setFetchStatus('UnableToSave')); */
      }
      return response.text();
    })
    .then(response => response)
    // .then(() => dispatch(setFetchLoading('loaded')))
    // .then(() => dispatch(setFetchLoading(false)))
    .catch((error) => {
      /* dispatch(setFetchStatus(error.message));
      dispatch(setFetchStatus('UnableToSave'));
      dispatch(setFetchLoading('loaded'));
      dispatch(setFetchLoading(false)); */
    });
};

export const loadIoStateByBookId = bookstate => ({
  type: LOAD_IO_STATE_BY_BOOK_ID,
  bookstate,
});



// WEBPACK FOOTER //
// ./src/redux/actions/entities/io.js